import React, {useState} from 'react';
import LoginBox from './LoginBox';
import LoginWrapper from '../../Shared/LoginWrapper';
import {
    useLocation
  } from "react-router-dom";

import { Redirect, Route } from 'react-router';
import CreatePassBox from '../CreatePass/CreatePassBox';
import ResetPassConfirm from './ResetPasswordConfirm'
import ForgotForm from '../ForgotPassword/ForgotForm'
import ForgotUsernameForm from '../ForgotUsername/ForgotUsernameForm'
import CheckContactEmail from '../CheckContactEmail';
import CustomSwitch from '../../Shared/RouteSwitch'

const Login = () => {

    const location = useLocation();

    return (
        <>
        <LoginWrapper>
            <CustomSwitch location={location} >
                <Route exact path='/login/forgot-username'>
                    <div className="z-10 w-full min-h-700px">
                        <ForgotUsernameForm />
                    </div>
                </Route>                
                <Route exact path='/login/forgot-username/check-email'>
                    <div className="z-10 w-full">
                        <CheckContactEmail
                            title="An email is on its way!"
                            buttonId="forgot-username-check-email-return-button"
                                buttonText="Return to Login"
                            buttonLink="/login"
                         >
                            We're on it!
                            <br />
                            If those details are correct, you will shortly receive a username reminder email
                        </CheckContactEmail>
                    </div>
                </Route>
                <Route exact path='/login/forgot'>
                    <div className="z-10 w-full min-h-700px">
                        <ForgotForm />
                    </div>
                </Route>
                <Route exact path='/login/forgot/check-email'>
                    <div className="z-10 w-full">
                        <CheckContactEmail
                            title="An email is on its way!"
                            buttonId="forgot-check-email-return-button"
                            buttonText="Return to Login"
                            buttonLink="/login"
                            >
                                We're on it!
                                <br />
                                If those details are correct, you will shortly receive a password reset email
                        </CheckContactEmail>
                    </div>
                </Route>
                <Route exact path='/login/forgot/confirm'>
                    <div className="z-10 w-full min-h-700px">
                        <ResetPassConfirm />
                    </div>
                </Route>
                <Route exact path='/login/confirm'>
                    <div className="z-10 w-full min-h-700px">
                        <CreatePassBox />
                    </div>
                </Route>
                <Route exact path='/login/check-email'>
                    <div className="z-10 w-full">
                        <CheckContactEmail
                            title="An email is on its way!"
                            buttonId="check-email-return-button"
                            buttonText="Return to Login"
                            buttonLink="/login"
                        >
                            We're on it!
                            <br />
                            If those details are correct, you will shortly receive an email to proceed with registration.
                        </CheckContactEmail>
                    </div>
                </Route>
                <Route exact path='/login'>
                    <div className="z-10 w-full min-h-700px">
                        <LoginBox />
                    </div>
                </Route>
                <Route exact path='/login/create'>
                    <div className="z-10 w-full min-h-700px">
                        <LoginBox />
                    </div>
                </Route>
                <Redirect to='/login' />
            </CustomSwitch>
        </LoginWrapper>
        </>
    )
}


export default Login;